import { useCallback, useState } from "react"

const storageKey = (key: string) => `sds:onboarding:snoozed:${key}`

/**
 * Remembers that an onboarding item was dismissed, for this browser session.
 *
 * `sessionStorage` on purpose: the task behind the item is still open, so a new
 * tab or a restart should offer it again. An item that is done for good (an
 * announcement the user has read) needs a persisted marker instead, not this.
 *
 * Storage can throw or be unavailable (private mode, blocked cookies). The item
 * then simply reappears next time, which is the harmless direction.
 */
export const useSessionSnooze = (key: string) => {
  const [isSnoozed, setIsSnoozed] = useState(() => {
    try {
      return sessionStorage.getItem(storageKey(key)) === "1"
    } catch {
      return false
    }
  })

  const snooze = useCallback(() => {
    try {
      sessionStorage.setItem(storageKey(key), "1")
    } catch {
      // Not persisted, but hiding it for now is still what the user asked for
    }
    setIsSnoozed(true)
  }, [key])

  return { isSnoozed, snooze }
}
